// replicates Bootstrap's <body class="modal-open"> toggle; counted in case two modals are open at once
let openCount = 0;

export const lockBodyScroll = () => {
    openCount += 1;
    document.body.classList.add('modal-open');
};

export const unlockBodyScroll = () => {
    openCount = Math.max(0, openCount - 1);
    if (openCount === 0) {
        document.body.classList.remove('modal-open');
    }
};
